import Axios from 'axios';
const ServiceURL = process.env.VUE_APP_SERVICEURL

export default {
    name: 'gudang',
    state: {
        gudang: [],
    },
    getters: {
        getAllGudang: state => {
            return state.gudang
        },
    },
    mutations: {
        GET_ALL_GUDANG: (state, payload) => {
            state.gudang = payload
        }
    },
    actions: {
        async FETCH_ALL_GUDANG(store) {
            return await Axios({
                method: "get",
                url: ServiceURL + "main/gudang",
                auth: {
                    username: store.rootState.user.auth.username,
                    password: store.rootState.user.auth.password
                },
                headers: {
                    "X-API-KEY": store.rootState.user.auth.apikey
                }
            }).then(response => {
                store.commit('GET_ALL_GUDANG', response.data.data);
                return store.state.gudang;
            })
                .catch(err => {
                    return err
                });
        },
    }
}